import type { CapabilityErrorUnion } from '../../capability/capabilityError';
import { makeCapabilityErrors } from '../../capability/capabilityError';

export const ListingVocabularyError = makeCapabilityErrors('ListingVocabulary');

export type ListingVocabularyError = CapabilityErrorUnion<typeof ListingVocabularyError>;
